var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxTicket2 = function Svg18PxTicket2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.5 9c0-.967.784-1.75 1.75-1.75v-1.5a2 2 0 0 0-2-2H3.75a2 2 0 0 0-2 2v1.5a1.75 1.75 0 1 1 0 3.5v1.5a2 2 0 0 0 2 2h10.5a2 2 0 0 0 2-2v-1.5A1.75 1.75 0 0 1 14.5 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M11.25 9.625a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11.25 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11.25 12.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })));
};
export default Svg18PxTicket2;